const INSERT_DIVIDER_BUTTON = "insert-divider-button";
const ROOT = "divider";
const PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON = "plugin-toolbar-divider-size-button";
const SIZE_DROPDDOWN_OPTION_SMALL = "size-dropdown-option-small";
const SIZE_DROPDDOWN_OPTION_MEDIUM = "size-dropdown-option-medium";
const SIZE_DROPDDOWN_OPTION_LARGE = "size-dropdown-option-large";
const PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON = "plugin-toolbar-divider-style-button";
const STYLE_DROPDOWN_OPTION_SINGLE = "style-dropdown-option-single";
const STYLE_DROPDOWN_OPTION_DOUBLE = "style-dropdown-option-double";
const STYLE_DROPDOWN_OPTION_DASHED = "style-dropdown-option-dashed";
const STYLE_DROPDOWN_OPTION_DOTTED = "style-dropdown-option-dotted";
export {
  INSERT_DIVIDER_BUTTON,
  PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON,
  PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON,
  ROOT,
  SIZE_DROPDDOWN_OPTION_LARGE,
  SIZE_DROPDDOWN_OPTION_MEDIUM,
  SIZE_DROPDDOWN_OPTION_SMALL,
  STYLE_DROPDOWN_OPTION_DASHED,
  STYLE_DROPDOWN_OPTION_DOTTED,
  STYLE_DROPDOWN_OPTION_DOUBLE,
  STYLE_DROPDOWN_OPTION_SINGLE
};
//# sourceMappingURL=data-hooks.js.map
